import {
  Image,
  Video,
  AudioLines,
  Box,
  FileText,
  Wrench,
  Sparkles,
  Wand2,
  Layers,
  Film,
  Maximize2,
  type LucideIcon,
} from 'lucide-react';

// Fixed set of workflow categories, kept in sync with the backend constant in
// backend/index.ts (WORKFLOW_CATEGORIES). Blends generation types (image, video,
// …) with task/use-case tags (prompt enhancing, motion design, …) so a workflow
// can be classified generically but with enough diversity to filter meaningfully.
export type WorkflowCategory =
  | 'image'
  | 'video'
  | 'audio'
  | '3d'
  | 'text'
  | 'prompt-enhancing'
  | 'motion-design'
  | 'design-variations'
  | 'upscaling'
  | 'editing'
  | 'utility';

export interface CategoryMeta {
  id: WorkflowCategory;
  label: string;
  icon: LucideIcon;
}

export const WORKFLOW_CATEGORIES: CategoryMeta[] = [
  // Generation types
  { id: 'image', label: 'Image', icon: Image },
  { id: 'video', label: 'Video', icon: Video },
  { id: 'audio', label: 'Audio', icon: AudioLines },
  { id: '3d', label: '3D Model', icon: Box },
  { id: 'text', label: 'Text / LLM', icon: FileText },
  // Task / use-case tags
  { id: 'prompt-enhancing', label: 'Prompt Enhancing', icon: Wand2 },
  { id: 'motion-design', label: 'Motion Design', icon: Film },
  { id: 'design-variations', label: 'Design Variations', icon: Layers },
  { id: 'upscaling', label: 'Upscaling', icon: Maximize2 },
  { id: 'editing', label: 'Editing', icon: Sparkles },
  { id: 'utility', label: 'Utility', icon: Wrench },
];

const CATEGORY_MAP = new Map(WORKFLOW_CATEGORIES.map((c) => [c.id, c]));

export const getCategoryMeta = (id: string): CategoryMeta | undefined => CATEGORY_MAP.get(id as WorkflowCategory);
